import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { fontIndivisibleVariable, theme } from "shared/lib/styles";

import { CoverImage } from "scmp-app/components/content/content-item-render/variants/post-magazine-section-widget-two/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { Swiper } from "scmp-app/components/swiper";

import IconArrowNext from "./icon-arrow-next.svg?url";
import IconArrowPrevious from "./icon-arrow-previous.svg?url";

export const Container = styled.div``;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;

  margin-block-end: 40px;
  padding-block-start: 40px;
  padding-inline: 20px;
  border-block-start: 1px solid #777777;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 40px;
    padding-inline: 0;
  }
`;

export const Title = styled(EntityLink)`
  color: #111111;
  font-weight: 300;
  font-size: 32px;
  font-family: ${fontIndivisibleVariable};
  line-height: 110%;
  letter-spacing: -1.6px;
  text-transform: uppercase;
  font-variation-settings: "wght" 300;

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 72px;
    letter-spacing: -3.6px;
  }
`;

export const Description = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;

    inline-size: 100%;
    max-inline-size: 300px;
    padding-inline-start: 24px;

    color: #111111;
    font-weight: 400;
    font-size: 16px;
    font-family: ${fontIndivisibleVariable};
    line-height: 26px;
    letter-spacing: -0.32px;
    text-align: end;
    font-variant-numeric: lining-nums proportional-nums;
    font-variation-settings: "wght" 400;

    border-inline-start: 1px solid #777777;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 420px;

    font-size: 18px;
    letter-spacing: -0.36px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  &.swiper {
    .swiper-pagination {
      inset-block-end: 0;

      padding-block-end: 21px;
      ${theme.breakpoints.up("tablet")} {
        padding-block-end: 40px;
      }
      ${theme.breakpoints.up("desktop")} {
        padding-block-end: 42px;
      }
    }

    .swiper-pagination-bullet {
      inline-size: 7px;
      block-size: 7px;
      margin-inline-start: 0 !important;

      background: #ffffff;

      opacity: 0.6;

      &:not(:last-child) {
        margin-inline-end: 10px;
      }

      ${theme.breakpoints.up("tablet")} {
        inline-size: 12px;
        block-size: 12px;
      }
    }

    .swiper-pagination-bullet-active {
      opacity: 1;
    }

    .swiper-button-next {
      direction: rtl;

      background-image: url(${IconArrowNext});
    }

    .swiper-button-prev {
      background-image: url(${IconArrowPrevious});
    }

    .swiper-button-next,
    .swiper-button-prev {
      inset-inline-start: 30px;

      box-shadow: none;

      opacity: 1;

      user-select: none;

      &.swiper-button-disabled {
        opacity: 0;
      }
    }

    ${CoverImage} {
      &:after {
        position: absolute;
        inset-block-end: 0;
        inset-inline: 0;
        content: "";

        inline-size: 100%;
        block-size: 243px;

        background: linear-gradient(to top, #111111 0%, transparent 100%);

        ${theme.breakpoints.up("desktop")} {
          block-size: 311px;
        }
      }
    }
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)``;
